var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"pulse",style:({ fontSize: `${_vm.rems}rem` })})
}
var staticRenderFns = []

export { render, staticRenderFns }